import { render, staticRenderFns } from "./animalType.vue?vue&type=template&id=589e969a&scoped=true&"
import script from "./animalType.vue?vue&type=script&lang=js&"
export * from "./animalType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e969a",
  null
  
)

export default component.exports